import logoImage from "../../assets/images/logo.svg";
import { storage } from "../../services/config/storage";

// Styles
import "./styles.scss";

function SecondaryHeader() {

  const gameDetails = storage.get.gameDetails();
  return (
    <div className="top-image-header">
      {
        gameDetails?.mediaUrl ?
        <img src={gameDetails.mediaUrl} alt="" />:
        <img src={logoImage} alt="" />
      }
      {
        gameDetails?.organizationName &&
        <p style={{ position: 'relative', fontSize: '16px', fontWeight: '200', top: '40px', color: 'white' }}>
          powered by <span style={{ fontWeight: '700' }}> {gameDetails.organizationName}</span>
        </p>
      }
    </div>
  );
}

export default SecondaryHeader;
